export default __webpack_public_path__ + "static/media/PurpleLabID.fc79a9e3.csv";